import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { AllInputTypes, FormInputConfig } from '../../../../trash/shared/interfaces/form-input-config';

export function getIdFormConfig(defaultValue: string | undefined): FormInputConfig {
  return {
    hide: true,
    type: AllInputTypes.Text,
    name: 'id',
    label: 'Id',
    defaultValue: defaultValue
  };
}

export function getIdFormlyConfig(defaultValue: string | undefined): FormlyFieldConfig {
  return {
    hide: true,
    type: AllInputTypes.Text,
    key: 'id',
    defaultValue: defaultValue
  };
}
